import { DgDynamicInputTestComponent } from './../dg-dynamic-input-test/dg-dynamic-input-test.component';
import { AuthenticationService } from './../../services/authentication.service';
import { AppInitService } from './../../services/app-init.service';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  OnInit,
  Inject,
  ViewChild,
} from '@angular/core';
import { MaskPipe } from 'ngx-mask';
import { forkJoin } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  ColPropConfig,
  ComboPropConfig,
  DgDynamicGridComponent,
  ExportOption,
  LegendConfig,
  Messages,
  Notify,
  RowDetailConfig,
} from 'dg-dynamic-grid-lib';
import { ComponentConfig, isComboTypeInput } from 'dg-input-lib';
import { AbstractControl, ValidatorFn } from '@angular/forms';

@Component({
  selector: 'app-dg-dynamic-grid-test',
  templateUrl: './dg-dynamic-grid-test.component.html',
  styleUrls: ['./dg-dynamic-grid-test.component.scss'],
})
export class DgDynamicGridTestComponent implements OnInit, AfterViewInit {
  @ViewChild('dynamicGrid') dynamicGrid: DgDynamicGridComponent;

  rows;
  cols;
  exportOptions: ExportOption[] = [
    {
      id: 0,
      label: 'print',
      icon: 'print',
    },
  ];
  showSearch = true;
  isExternalSearch = false;
  isExternalSorting = false;
  isLoading = false;
  isEditable = true;
  canAddRow = true;
  isSaveAll = false;
  addRowAtTop = true;
  isRowSelectable = false;
  allowMultiRowSelection = false;
  showCheckboxForSelection = false;
  canEditInline = true;
  beginWithAddedRow = false;
  pinColumn = 'right';
  pageSize: number = 5;
  isExternalPaging = false;
  totalRows: number = 0;
  isDeleteAll = false;
  canAddMultipleRows = true;
  canDeleteMultipleRows = true;
  configAtRow = false;
  isRowExpandable = false;
  showEmptyIllustration = true;
  showColumnSelection = true;
  rowDetailConfig: RowDetailConfig;
  offset: number = 0;
  messages: Messages = {
    emptyMessage: `No records found. Click on Add Row to add a new row ;-)`,
    totalMessage: 'total',
    selectedMessage: 'selected',
  };
  legends: LegendConfig[];

  colPropConfig: ColPropConfig = {
    idProp: 'columnId',
    nameProp: 'columnName',
    typeProp: 'type',
    placeholderProp: 'placeholder',
    requiredProp: 'mandatory',
    comboProp: 'comboItems',
    validationsProp: 'validations',
  };

  // colPropConfig = { idProp: 'prop', nameProp: 'name', typeProp: 'type' };
  comboPropConfig: ComboPropConfig = {
    labelProp: 'optionText',
    valueProp: 'optionValue',
    disabledProp: 'optionDisabled',
    iconProp: 'optionIcon',
  };
  doc_url;

  finalData;
  notifier;

  datePipe: DatePipe;
  tempData: any;

  constructor(
    private http: HttpClient,
    private maskPipe: MaskPipe,
    private dialog: MatDialog,
    private appInitService: AppInitService,
    private authService: AuthenticationService
  ) {
    this.datePipe = new DatePipe('en-IN');
  }

  ngOnInit(): void {
    this.doc_url =
      this.appInitService?.appConfig?.dgDocUrl +
      '/components/DgDynamicGridComponent.html';
    this.refreshGrid();
    const cc = new ComponentConfig();
    cc.componentAddress = DgDynamicInputTestComponent;
    cc.componentInputs = {};
    cc.componentOutputs = {};
    this.rowDetailConfig = {
      component: cc,
      formInvalid: (componentInstance: DgDynamicInputTestComponent) =>
        componentInstance?.dgDynamicInputFormGroup?.invalid,
    };
  }

  ngAfterViewInit() {
    // Application Developer Code... ;-)
  }

  getData = () =>
    this.http
      ?.get(
        `http://localhost:3000/${this.configAtRow ? 'dynamicAtRow' : 'dynamic'}`
      )
      ?.pipe(
        map((response: any) => response?.data),
        catchError((error) => {
          this.isLoading = false;
          throw error;
        })
      );

  refreshGrid = () => {
    // this.isLoading = true;
    // this.getData().subscribe((data) => {
    //   this.isLoading = false;
    //   this.rows = data?.rows;
    //   this.finalData = this.rows?.toString() ? [...this.rows] : [];
    //   this.cols = data?.columns;
    //   this.legends = data?.legends;
    //   this.updateCols();
    // });

    this.cols = [
      {
        columnName: 'pk',
        columnId: 'pk',
        displayable: false,
      },
      {
        columnName: 'SSN No.',
        columnId: 'ssn',
        width: 100,
        type: 3,
        mask: '000-000-0000',
        isLink: false,
        align: 'center',
        headerAlign: 'center',
        icons: false,
        displayable: true,
        sortable: true,
        searchable: true,
        pipe: {
          instance: {
            _maskService: {
              _config: {
                suffix: '',
                prefix: '',
                thousandSeparator: ' ',
                decimalMarker: '.',
                clearIfNotMatch: false,
                showTemplate: false,
                showMaskTyped: false,
                placeHolderCharacter: '_',
                dropSpecialCharacters: true,
                shownMaskExpression: '',
                separatorLimit: '',
                allowNegativeNumbers: false,
                validation: true,
                specialCharacters: [
                  '-',
                  '/',
                  '(',
                  ')',
                  '.',
                  ':',
                  ' ',
                  '+',
                  ',',
                  '@',
                  '[',
                  ']',
                  '"',
                  "'",
                ],
                patterns: {
                  '0': {
                    pattern: {},
                  },
                  '9': {
                    pattern: {},
                    optional: true,
                  },
                  X: {
                    pattern: {},
                    symbol: '*',
                  },
                  A: {
                    pattern: {},
                  },
                  S: {
                    pattern: {},
                  },
                  d: {
                    pattern: {},
                  },
                  m: {
                    pattern: {},
                  },
                  M: {
                    pattern: {},
                  },
                  H: {
                    pattern: {},
                  },
                  h: {
                    pattern: {},
                  },
                  s: {
                    pattern: {},
                  },
                },
              },
              maskExpression: '',
              actualValue: '',
              shownMaskExpression: '',
              _shift: {},
              clearIfNotMatch: false,
              dropSpecialCharacters: true,
              maskSpecialCharacters: [
                '-',
                '/',
                '(',
                ')',
                '.',
                ':',
                ' ',
                '+',
                ',',
                '@',
                '[',
                ']',
                '"',
                "'",
              ],
              maskAvailablePatterns: {
                '0': {
                  pattern: {},
                },
                '9': {
                  pattern: {},
                  optional: true,
                },
                X: {
                  pattern: {},
                  symbol: '*',
                },
                A: {
                  pattern: {},
                },
                S: {
                  pattern: {},
                },
                d: {
                  pattern: {},
                },
                m: {
                  pattern: {},
                },
                M: {
                  pattern: {},
                },
                H: {
                  pattern: {},
                },
                h: {
                  pattern: {},
                },
                s: {
                  pattern: {},
                },
              },
              prefix: '',
              suffix: '',
              thousandSeparator: ' ',
              decimalMarker: '.',
              showMaskTyped: false,
              placeHolderCharacter: '_',
              validation: true,
              separatorLimit: '',
              allowNegativeNumbers: false,
            },
          },
          parameters: ['000-000-0000'],
        },
      },
      {
        columnName: 'Department',
        columnId: 'dept',
        placeholder: 'Place Dept',
        width: 150,
        type: 5,
        mdmcomboId: '3505',
        isLink: false,
        headerAlign: 'center',
        align: 'center',
        icons: false,
        displayable: true,
        sortable: true,
        searchable: true,
        comboItems: [
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '3000865',
            optionIcon: 'notifications',
            optionDisabled: true,
            optionText: 'a',
            optionDesc: '',
            attrValue: '',
          },
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '70001572',
            optionIcon: 'mail',
            optionText: 'b',
            optionDesc: '',
            attrValue: '',
          },
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '70001573',
            optionIcon: 'message',
            optionText: 'c',
            optionDesc: '',
            attrValue: '',
          },
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '70001574',
            optionIcon: 'alarm',
            optionText: 'd',
            optionDesc: '',
            attrValue: '',
          },
        ],
      },
      {
        columnName: 'Designation',
        columnId: 'designation',
        placeholder: 'Place desig',
        width: 120,
        isLink: true,
        type: null,
        headerAlign: 'center',
        align: 'center',
        icons: false,
        sortable: true,
        displayable: true,
        defaultValue: 'imdefault',
        searchable: true,
      },
      {
        columnName: 'Current No.',
        columnId: 'current',
        placeholder: 'cur place',
        width: 150,
        type: 1,
        isLink: false,
        value: '',
        headerAlign: 'right',
        align: 'right',
        icons: false,
        sortable: true,
        displayable: true,
        searchable: true,
        validations: [
          {
            id: 0,
            async: false,
            type: 'min',
            value: 0,
            errorMessage: 'please enter value between 0 and 100',
          },
          {
            id: 2,
            async: false,
            type: 'max',
            value: 100,
            errorMessage: 'please enter value between 0 and 100',
          },
          {
            id: 1,
            async: false,
            type: 'required',
            value: null,
            errorMessage: 'Please enter valid data',
          },
        ],
      },
      {
        columnName: 'Notification icon',
        columnId: 'notificationIcon',
        width: 110,
        type: null,
        isLink: false,
        align: 'center',
        headerAlign: 'center',
        icons: true,
        iconConfig: [
          {
            id: 1,
            icon: 'print',
            isDisabled: false,
          },
          {
            id: 2,
            icon: 'message',
            isDisabled: false,
          },
        ],
        displayable: true,
        sortable: false,
      },
      {
        columnName: 'Time',
        columnId: 'start_time',
        width: 150,
        isLink: false,
        value: '',
        type: 16,
        headerAlign: 'right',
        align: 'right',
        icons: false,
        sortable: true,
        searchable: true,
        displayable: true,
      },
      {
        columnName: 'Date',
        columnId: 'start_date',
        width: 150,
        isLink: false,
        value: '',
        type: 0,
        headerAlign: 'right',
        align: 'right',
        icons: false,
        sortable: true,
        displayable: true,
        searchable: true,
        validations: [
          {
            id: 0,
            async: false,
            type: 'required',
            value: null,
            errorMessage: 'Please select a date',
          },
        ],
        pipe: {
          instance: {
            locale: 'en-IN',
          },
          parameters: ['shortDate'],
        },
      },
      {
        columnName: 'Role',
        columnId: 'role',
        width: 150,
        type: 41,
        isLink: false,
        mdmcomboId: '3505',
        headerAlign: 'center',
        align: 'center',
        icons: false,
        sortable: true,
        displayable: true,
        searchable: true,
        comboItems: [
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '3000865',
            optionIcon: 'notifications',
            optionDisabled: true,
            optionText: 'a',
            optionDesc: '',
            attrValue: '',
          },
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '70001572',
            optionIcon: 'mail',
            optionText: 'b',
            optionDesc: '',
            attrValue: '',
          },
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '70001573',
            optionIcon: 'message',
            optionText: 'c',
            optionDesc: '',
            attrValue: '',
          },
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '70001574',
            optionIcon: 'alarm',
            optionText: 'd',
            optionDesc: '',
            attrValue: '',
          },
        ],
      },
      {
        columnName: 'Organization',
        columnId: 'org',
        width: 200,
        isLink: false,
        type: 26,
        headerAlign: 'center',
        align: 'center',
        icons: false,
        sortable: true,
        displayable: false,
        searchable: true,
        validations: [],
      },
      {
        columnName: 'Actions',
        columnId: 'actions',
        width: 110,
        type: null,
        icons: true,
        headerAlign: 'center',
        align: 'center',
        sortable: false,
        displayable: true,
        actionConfig: [
          {
            actionName: 'save',
            actionIcon: 'save',
            isVisible: false,
            isDisabled: false,
          },
          {
            actionName: 'edit',
            actionIcon: 'edit',
            isVisible: true,
            isDisabled: false,
          },
          {
            actionName: 'up',
            actionIcon: 'arrow_upward',
            isVisible: true,
            isDisabled: false,
          },
          {
            actionName: 'down',
            actionIcon: 'arrow_downward',
            isVisible: true,
            isDisabled: false,
          },
          {
            actionName: 'delete',
            actionIcon: 'delete',
            isVisible: true,
            isDisabled: false,
          },
          {
            actionName: 'clear',
            actionIcon: 'cached',
            isVisible: false,
            isDisabled: false,
          },
          {
            actionName: 'close',
            actionIcon: 'close',
            isVisible: false,
            isDisabled: false,
          },
        ],
      },
    ];
    this.rows = [
      {
        pk: 8,
        ssn: null,
        dept: {
          extendedVO: null,
          customXidBean: null,
          dbSchema: null,
          optionValue: '70001573',
          optionIcon: 'message',
          optionText: 'c',
          optionDesc: '',
          attrValue: '',
        },
        designation: 'imdefault',
        current: 70,
        notificationIcon: [
          {
            id: 1,
            icon: 'print',
            isDisabled: false,
          },
          {
            id: 2,
            icon: 'message',
            isDisabled: false,
          },
        ],
        start_time: null,
        start_date: '2021-05-24T18:30:00.000Z',
        role: [],
        actions: [
          {
            actionName: 'save',
            actionIcon: 'save',
            isVisible: false,
            isDisabled: false,
          },
          {
            actionName: 'edit',
            actionIcon: 'edit',
            isVisible: true,
            isDisabled: false,
          },
          {
            actionName: 'up',
            actionIcon: 'arrow_upward',
            isVisible: true,
            isDisabled: false,
          },
          {
            actionName: 'down',
            actionIcon: 'arrow_downward',
            isVisible: true,
            isDisabled: false,
          },
          {
            actionName: 'delete',
            actionIcon: 'delete',
            isVisible: true,
            isDisabled: false,
          },
          {
            actionName: 'clear',
            actionIcon: 'cached',
            isVisible: false,
            isDisabled: false,
          },
          {
            actionName: 'close',
            actionIcon: 'close',
            isVisible: false,
            isDisabled: false,
          },
        ],
      },
      {
        pk: 6,
        ssn: null,
        dept: {
          extendedVO: null,
          customXidBean: null,
          dbSchema: null,
          optionValue: '70001572',
          optionIcon: 'mail',
          optionText: 'b',
          optionDesc: '',
          attrValue: '',
        },
        designation: 'imdefault',
        current: 23,
        notificationIcon: [
          {
            id: 1,
            icon: 'print',
            isDisabled: false,
          },
          {
            id: 2,
            icon: 'message',
            isDisabled: false,
          },
        ],
        start_time: null,
        start_date: '2021-05-09T18:30:00.000Z',
        role: [],
        actions: [
          {
            actionName: 'save',
            actionIcon: 'save',
            isVisible: false,
            isDisabled: false,
          },
          {
            actionName: 'edit',
            actionIcon: 'edit',
            isVisible: true,
            isDisabled: false,
          },
          {
            actionName: 'up',
            actionIcon: 'arrow_upward',
            isVisible: true,
            isDisabled: false,
          },
          {
            actionName: 'down',
            actionIcon: 'arrow_downward',
            isVisible: true,
            isDisabled: false,
          },
          {
            actionName: 'delete',
            actionIcon: 'delete',
            isVisible: true,
            isDisabled: false,
          },
          {
            actionName: 'clear',
            actionIcon: 'cached',
            isVisible: false,
            isDisabled: false,
          },
          {
            actionName: 'close',
            actionIcon: 'close',
            isVisible: false,
            isDisabled: false,
          },
        ],
      },
      {
        pk: 5,
        ssn: '2343434354',
        dept: {
          extendedVO: null,
          customXidBean: null,
          dbSchema: null,
          optionValue: '70001572',
          optionIcon: 'mail',
          optionText: 'b',
          optionDesc: '',
          attrValue: '',
        },
        designation: 'imdefault',
        current: 66,
        notificationIcon: [
          {
            id: 1,
            icon: 'print',
            isDisabled: false,
          },
          {
            id: 2,
            icon: 'message',
            isDisabled: false,
          },
        ],
        start_time: null,
        start_date: '2021-05-03T18:30:00.000Z',
        role: [],
        org: null,
        actions: [
          {
            actionName: 'save',
            actionIcon: 'save',
            isVisible: false,
            isDisabled: false,
          },
          {
            actionName: 'edit',
            actionIcon: 'edit',
            isVisible: true,
            isDisabled: false,
          },
          {
            actionName: 'up',
            actionIcon: 'arrow_upward',
            isVisible: true,
            isDisabled: false,
          },
          {
            actionName: 'down',
            actionIcon: 'arrow_downward',
            isVisible: true,
            isDisabled: false,
          },
          {
            actionName: 'delete',
            actionIcon: 'delete',
            isVisible: true,
            isDisabled: false,
          },
          {
            actionName: 'clear',
            actionIcon: 'cached',
            isVisible: false,
            isDisabled: false,
          },
          {
            actionName: 'close',
            actionIcon: 'close',
            isVisible: false,
            isDisabled: false,
          },
        ],
      },
      {
        pk: 3,
        ssn: '1111111111',
        dept: {
          extendedVO: null,
          customXidBean: null,
          dbSchema: null,
          optionValue: '70001572',
          optionIcon: 'mail',
          optionText: 'b',
          optionDesc: '',
          attrValue: '',
        },
        designation: 'kljm',
        current: 55,
        start_date: '2021-02-14T18:30:00.000Z',
        role: [
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '3000865',
            optionIcon: 'notifications',
            optionDisabled: true,
            optionText: 'a',
            optionDesc: '',
            attrValue: '',
          },
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '70001572',
            optionIcon: 'mail',
            optionText: 'b',
            optionDesc: '',
            attrValue: '',
          },
        ],
        org: {
          id: 54,
          name: 'Law',
          shrtName: 'Law',
          description: 'Law',
          typeName: null,
          prntId: -1,
          startDate: '23-04-2010',
          endDate: null,
          typeId: 10,
          langId: null,
          locId: null,
          prntTypeId: null,
          activeFlag: null,
          attachId: 130576464,
          childCount: 0,
          siblingsCount: 0,
          sectionCount: 0,
          postCount: 0,
          location: null,
          code: '123',
        },
        notificationIcon: [
          {
            isDisabled: false,
          },
          {
            isDisabled: true,
          },
        ],
        start_time: '15:03',
      },
      {
        pk: 2,
        dept: {
          extendedVO: null,
          customXidBean: null,
          dbSchema: null,
          optionValue: '70001573',
          optionIcon: 'message',
          optionText: 'c',
          optionDesc: '',
          attrValue: '',
        },
        designation: 'imdefault',
        notificationIcon: [
          {
            id: 1,
            icon: 'print',
            isDisabled: false,
          },
          {
            id: 2,
            icon: 'message',
            isDisabled: false,
          },
        ],
        start_date: '2021-02-15T18:30:00.000Z',
        role: [
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '70001572',
            optionIcon: 'mail',
            optionText: 'b',
            optionDesc: '',
            attrValue: '',
          },
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '70001574',
            optionIcon: 'alarm',
            optionText: 'd',
            optionDesc: '',
            attrValue: '',
          },
        ],
        ssn: '2222222222',
        current: 1,
        start_time: null,
      },
      {
        pk: 4,
        ssn: '3333333333',
        dept: {
          extendedVO: null,
          customXidBean: null,
          dbSchema: null,
          optionValue: '3000865',
          optionIcon: 'notifications',
          optionDisabled: true,
          optionText: 'a',
          optionDesc: '',
          attrValue: '',
        },
        designation: 'as',
        current: 22,
        start_time: '14:55',
        start_date: '2021-02-14T18:30:00.000Z',
        role: [
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '3000865',
            optionIcon: 'notifications',
            optionDisabled: true,
            optionText: 'a',
            optionDesc: '',
            attrValue: '',
          },
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '70001572',
            optionIcon: 'mail',
            optionText: 'b',
            optionDesc: '',
            attrValue: '',
          },
        ],
        org: [
          {
            id: 3000864,
            name: 'Administrator',
            shrtName: 'Adm',
            description: 'Administrator',
            typeName: null,
            prntId: 54,
            startDate: '23-08-2006',
            endDate: null,
            typeId: 12,
            langId: null,
            locId: null,
            prntTypeId: null,
            activeFlag: null,
            attachId: 0,
            childCount: 0,
            siblingsCount: 0,
            sectionCount: 0,
            postCount: 0,
            location: null,
            code: null,
          },
        ],
      },
    ];
    this.legends = [
      {
        legendId: 1,
        legendColor: '#98ABDF',
        legendName: 'Old',
      },
      {
        legendId: 2,
        legendColor: '#F2C7C7',
        legendName: 'New',
      },
      {
        legendId: 3,
        legendColor: '#7DDC80',
        legendName: 'Shadow',
      },
      {
        legendId: 4,
        legendColor: '#000000',
        legendName: 'Parallel',
      },
      {
        legendId: 5,
        legendColor: '#F4FF56',
        legendName: 'Approved',
      },
      {
        legendId: 6,
        legendColor: '#FF4E4E',
        legendName: 'Others',
      },
      {
        legendId: 7,
        legendColor: '#58A5CC',
        legendName: 'Pending',
      },
    ];
    this.updateCols();
  };

  updateCols = () => {
    const loadComboTasks = [];

    this.cols?.forEach((col) => {
      // applying pipe example (application developer will write corresponding logic)
      if (col?.columnId === 'ssn') {
        /* col.type = 50;
        col.multiSelect = false;
        col.isLink = true;
        col.component = new ComponentConfig();
        col.component.componentAddress = DgPostSearchComponent;
        col.component.componentInputs = {
          postConfig: {
            multiSelect: false,
            header: 'Post Search',
            minLengthforSearch: 3,
            minLengthforSearchMsg:
              'Please enter 3 or more characters to search.',
          },
          selectedPosts: [1],
        };
        col.component.componentOutputs = { output: null, change: null }; */
        col['pipe'] = { instance: this.maskPipe, parameters: ['000-000-0000'] };
      }
      if (col?.columnId === 'start_date') {
        col['pipe'] = { instance: this.datePipe, parameters: ['shortDate'] };
      }

      // load combos
      // if (isComboTypeInput(col?.type) && col?.mdmcomboId) {
      //   const dataForPost = {
      //     ACTIVE_FLAG: '1',
      //     LOC_ID: '1',
      //     LANG_ID: '1',
      //     ComboId: `${col?.mdmcomboId}`,
      //   };
      //   console.log('getting combo: ', dataForPost?.ComboId);
      //   loadComboTasks.push(
      //     this.http
      //       .get(`http://localhost:3000/getComboOptions` /* , dataForPost */)
      //       .pipe(
      //         map((response: any) => response?.data),
      //         catchError((error) => {
      //           throw error;
      //         })
      //       )
      //   );
      // }
    });
    // if (loadComboTasks) {
    //   try {
    //     forkJoin(loadComboTasks).subscribe((response) => {
    //       console.log('fork: ', response);
    //       let i = 0;
    //       this.cols?.forEach((col) => {
    //         if (isComboTypeInput(col?.type)) col.comboItems = response[i++];
    //       });
    //       this.cols = this.cols?.toString() ? [...this.cols] : [];
    //       // this.updateRows();
    //     });
    //   } catch (error) {
    //     console.log('Diff error::::::::: ', error);
    //   }
    // }
    this.cols?.forEach((col) => {
      if (isComboTypeInput(col?.type))
        col.comboItems = [
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '3000865',
            optionIcon: 'notifications',
            optionDisabled: true,
            optionText: 'a',
            optionDesc: '',
            attrValue: '',
          },
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '70001572',
            optionIcon: 'mail',
            optionText: 'b',
            optionDesc: '',
            attrValue: '',
          },
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '70001573',
            optionIcon: 'message',
            optionText: 'c',
            optionDesc: '',
            attrValue: '',
          },
          {
            extendedVO: null,
            customXidBean: null,
            dbSchema: null,
            optionValue: '70001574',
            optionIcon: 'alarm',
            optionText: 'd',
            optionDesc: '',
            attrValue: '',
          },
        ];
    });
    this.cols = [...this.cols];
    // this.updateRows();
  };

  updateRows = (rowIndex = '') => {
    /* this.rows?.forEach((r) => {
      const form = new FormGroup({
        url: new FormControl(null),
      });

      const cc = new ComponentConfig();
      cc.componentAddress = DgDynamicInputTestComponent;
      cc.componentInputs = { form };
      cc.componentOutputs = {};
      r.rowDetailComponent = cc;
    }); */

    if (this.rows?.toString()) this.rows = [...this.rows];
  };

  onLinkClick = ({ rowIndex, row }) => {
    // Application Developer Code... ;-)
    console.log('onLinkClick: ', rowIndex);
    console.log('onLinkClick: ', row);
  };

  onIconClick = ({ rowIndex, iconId }) => {
    // Application Developer Code... ;-)
    console.log('onIconClick: ', rowIndex);
  };

  onExportOptionClick = (eo: ExportOption) => {
    // Application Developer Code... ;-)
    console.log('onExportOptionClick: ', eo);
  };

  onFilterChange = ({ col, cols }) => {
    // Application Developer Code... ;-)
    console.log('Filter Changed', col, cols);
  };

  onSearchQueryChange = (searchQuery) => {
    // Application Developer Code... ;-)
    if (!this.isExternalSearch) return;
    this.isLoading = true;
    this.http
      ?.get('http://localhost:3000/dynamic/search', {
        params: new HttpParams().set('searchQuery', searchQuery),
      })
      .pipe(
        map((response: any) => response?.data),
        catchError((error) => {
          this.isLoading = false;
          throw error;
        })
      )
      .subscribe((data) => (this.rows = data?.rows));
  };

  onSort = ({ direction, columnId, columnIndex }) => {
    // Application Developer Code... ;-)
    this.isLoading = true;
    this.http
      ?.get('http://localhost:3000/dynamic/sort')
      ?.pipe(
        map((response: any) => response?.data),
        catchError((error) => {
          this.isLoading = false;
          throw error;
        })
      )
      .subscribe((data) => {
        this.rows = data?.rows;
        this.isLoading = false;
      });
  };

  onPageChange = ({ count, pageSize, limit, offset }) => {
    // Application Developer Code... ;-)
    this.offset = offset;
    if (this.isExternalPaging) {
      this.isLoading = true;
      this.http
        ?.get('http://localhost:3000/dynamic2')
        ?.pipe(
          map((response: any) => response?.data),
          catchError((error) => {
            this.isLoading = false;
            throw error;
          })
        )
        .subscribe((data) => {
          this.rows = data?.rows;
          this.isLoading = false;
        });
    }
  };

  onRowSelection = (selected) => {
    // Application Developer Code... ;-)
    // { selected }
    console.log('selected::::>>>> ', selected);

    this.rows?.forEach((row, index) => {
      row.selected = selected
        ?.map((selectedRow) => selectedRow?.rowIndex)
        ?.includes(index);
    });
  };

  onInputChange = ({
    data,
    currentValue,
    formControlValue,
    row,
    rowIndex,
    notifier,
  }) => {
    // Application Developer Code... ;-)
    console.log('onInputChange: ', rowIndex);
    console.log('onInputChange: ', row);
    // const notify: Notify = { status: -1, data: { ssn: '9999999999' } };
    // notifier?.next(notify);
    // if (data?.columnId === 'role') this.dynamicGrid?.toggleExpandRow(row);

    /* console.log(
      'asdfdsfldsakfshjdfsdlaf::::::',
      this.dynamicGrid?. as DgDynamicInputTestComponent
    ); */

    if (data?.columnId === 'parameter') {
      const type = formControlValue?.optionValue;
      const data = {
        ...row,
        parameter: formControlValue,
        name: { cellConfig: { columnId: 'name', type }, value: null },
      };
      const notify: Notify = { status: -1, data };
      notifier?.next(notify);
    }
  };

  onActionPerformed({ rowIndex, row, action, data, notifier }) {
    console.log(rowIndex);
    console.log(row);
    console.log(action);
    console.log(data);
    console.log(notifier);

    console.log(
      'rowDetailComponentRef: ',
      this.dynamicGrid?.rowDetailComponentRef
    );

    console.log('rowIndex:::::::::::::: ', rowIndex);
    const url = `http://localhost:3000/${
      this.configAtRow ? 'dynamicAtRow' : 'dynamic'
    }`;
    let notify: Notify;

    if (this.isSaveAll) {
      this.notifier = notifier;
      if (
        action === 'update' ||
        action === 'create' ||
        action === 'delete' ||
        action === 'addMultiple' ||
        action === 'deleteMultiple'
      ) {
        this.finalData = [...data];
      }
      return;
    }
    switch (action) {
      case 'close':
        if (row.expanded) this.dynamicGrid.toggleExpandRow(row);
        break;
      case 'edit':
        // window.alert(`edit: ${rowIndex} ${JSON.stringify(row)}`);
        break;
      case 'up':
        let currentIndex = this.rows?.findIndex((r) => r?.pk === row?.pk);
        let nextIndex = currentIndex === 0 ? currentIndex : currentIndex - 1;
        moveItemInArray(this.rows, currentIndex, nextIndex);
        this.updateRows();
        break;
      case 'down':
        let currentIndex1 = this.rows?.findIndex((r) => r?.pk === row?.pk);
        let nextIndex1 =
          currentIndex1 === this.rows?.length - 1
            ? currentIndex1
            : currentIndex1 + 1;
        moveItemInArray(this.rows, currentIndex1, nextIndex1);
        this.updateRows();
        break;
      case 'create':
        row.pk = Math.ceil(Math.random() * 1000000);
        // this.http
        //   ?.post(url, {
        //     data: {
        //       columns: [...this.cols],
        //       rows: this.addRowAtTop
        //         ? [row, ...this.rows]
        //         : [...this.rows, row],
        //       legends: this.legends,
        //     },
        //   })
        //   .pipe(
        //     catchError((error) => {
        //       notify = { status: 0, error };
        //       notifier?.next(notify);
        //       throw error;
        //     })
        //   )
        //   .subscribe(() => {
        //     this.rows = this.addRowAtTop
        //       ? [row, ...this.rows]
        //       : [...this.rows, row];
        //     notify = { status: 1, data: { row } };
        //     notifier?.next(notify);
        //     console.log(`${action} successful`);
        //     this.updateRows();
        //     // this.refreshGrid();
        //   });
        this.rows = this.addRowAtTop
          ? [row, ...this.rows]
          : [...this.rows, row];
        notify = { status: 1, data: { row } };
        notifier?.next(notify);
        console.log(`${action} successful`);
        this.updateRows();
        break;

      case 'update':
        // let index = this.rows?.findIndex(
        //   (r) => r.pk?.toString() && r.pk === row.pk
        // );
        // this.rows[index] = { ...this.rows[index], ...row };
        // this.http
        //   ?.put(url, {
        //     data: {
        //       columns: [...this.cols],
        //       rows: [...this.rows],
        //       legends: this.legends,
        //     },
        //   })
        //   .pipe(
        //     catchError((error) => {
        //       notify = { status: 0, error };
        //       notifier?.next(notify);
        //       throw error;
        //     })
        //   )
        //   .subscribe(() => {
        //     notify = { status: 1, data: { row } };
        //     notifier?.next(notify);
        //     console.log(`${action} successful`);
        //     this.updateRows();
        //     // this.refreshGrid();
        //   });
        let index = this.rows?.findIndex(
          (r) => r.pk?.toString() && r.pk === row.pk
        );
        this.rows[index] = { ...this.rows[index], ...row };
        // this.rows[rowIndex] = { ...this.rows[rowIndex], ...data };
        // this.updateRows(rowIndex);
        notify = { status: 1, data: { row } };
        notifier?.next(notify);
        console.log(`${action} successful`);
        this.updateRows();
        break;

      case 'delete':
        const dialogRef = this.dialog.open(SampleDialogComponent, {
          width: '250px',
          data: { message: 'Do you want to delete?' },
        });

        dialogRef.afterClosed().subscribe((result) => {
          console.log('The dialog was closed: ', result);

          if (result) {
            this.rows = this.rows?.filter(
              (r) => r.pk?.toString() && r.pk !== row.pk
            );

            notify = { status: 1, data: { row } };
            notifier?.next(notify);
            console.log(`${action} successful`);
            this.updateRows();
          }
        });

        /************** */

        // dialogRef.afterClosed().subscribe((result) => {
        //   console.log('The dialog was closed: ', result);
        //   if (result) {
        //     this.http
        //     ?.put(url, {
        //       data: {
        //         columns: [...this.cols],
        //         rows: [...this.rows?.filter(
        //           (r) => r.pk?.toString() && r.pk !== row.pk),
        //         ],
        //         legends: this.legends,
        //       },
        //     })
        //     .pipe(
        //       catchError((error) => {
        //         notify = { status: 0, error };
        //         notifier?.next(notify);
        //         throw error;
        //       })
        //     )
        //     .subscribe(() => {
        //       this.rows = [
        //         ...this.rows?.filter(
        //           (r) => r.pk?.toString() && r.pk !== row.pk
        //         ),
        //       ];
        //       notify = { status: 1, data: { row } };
        //       notifier?.next(notify);
        //       console.log(`${action} successful`);
        //       this.updateRows();
        //       // this.refreshGrid();
        //     });
        //   }
        // });
        // // this.rows = this.rows?.filter((row) => row !== this.rows[rowIndex]);
        // // notifier?.next({ rowIndex });

        /******************* */

        break;
    }
  }

  submit() {
    const url = `http://localhost:3000/${
      this.configAtRow ? 'dynamicAtRow' : 'dynamic'
    }`;
    let notify: Notify;
    console.log('dynamicGridData: ', this.finalData);
    this.http
      ?.post(url, {
        data: {
          rows: this.finalData ? [...this.finalData] : [],
          columns: this.cols ? [...this.cols] : [],
        },
      })
      .pipe(
        catchError((error) => {
          notify = { status: 0, error };
          this.notifier?.next(notify);
          throw error;
        })
      )
      .subscribe(() => {
        notify = { status: 1 };
        this.notifier?.next(notify);
        this.refreshGrid();
      });
  }
}

@Component({
  selector: 'sample-dialog',
  template: `
    <div>
      <span>{{ data?.message }}</span>
      <mat-dialog-actions class="text-end">
        <button mat-button [mat-dialog-close]="false">Cancel</button>
        <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
      </mat-dialog-actions>
    </div>
  `,
})
export class SampleDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SampleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) {}

  ngOnInit(): void {}
}
